<template>
  <div class="processed-by mt-1">Auto Pass</div>
</template>

<script>
export default {}
</script>
